import React, { useState } from 'react';
import IntlMessages from 'Util/IntlMessages';
import icBackArrow1 from 'Assets/img/ic_arrow_right_16.png';
import icBackArrow2 from 'Assets/img/ic_arrow_right_16@2x.png';
import icBackArrow3 from 'Assets/img/ic_arrow_right_16@3x.png';
import icArrow1 from 'Assets/img/setting/ic_arrow_blue.png';
import icArrow2 from 'Assets/img/setting/ic_arrow_blue@2x.png';
import icArrow3 from 'Assets/img/setting/ic_arrow_blue@3x.png';
import { getImageSet } from 'Util/DataUtils';
import { BUSINESS_TYPE } from '../../constants';
import SelectForm from './SelectForm';
import VerificationForm from 'Routes/sign-in/components/common/VerificationForm';
import { VERIFY_TYPE } from 'Routes/sign-in/components/LeftSide/constants';
import IndividualJoinForm from 'Routes/sign-in/components/common/IndividualJoinForm';
import FreelancerJoinForm from 'Routes/sign-in/components/common/FreelancerJoinForm';

const icArrow = getImageSet([icArrow1, icArrow2, icArrow3]);
const icBackArrow = getImageSet([icBackArrow1, icBackArrow2, icBackArrow3]);
const STEP = {
  SELECT: 1,
  VERIFY: 2,
  JOIN: 3,
};

const JoinViSection = ({ onChangeLogin, onCompleted }) => {
  const [showMethod, setShowMethod] = useState(false);
  const [step, setStep] = useState(STEP.SELECT);
  const [businessType, setBusinessType] = useState(null);
  const [phone, setPhone] = useState('');
  const [otpCode, setOtpCode] = useState('');

  const handleBack = () => {
    if (step === STEP.SELECT) {
      onChangeLogin();
    } else {
      setStep(step - 1);
    }
  };

  const handleGoVerify = ({ _businessType }) => {
    setStep(STEP.VERIFY);
    setBusinessType(_businessType);
  };

  const handleGoJoin = ({ phone, otpCode }) => {
    setStep(STEP.JOIN);
    setPhone(phone);
    setOtpCode(otpCode);
  };

  const getTitle = () => {
    if (step === STEP.SELECT) return 'sign.join';
    if (step === STEP.VERIFY) return 'signIn.join.phone.verify';
    if (businessType === BUSINESS_TYPE.FREELANCER) return 'signIn.join.personal.2';
    return 'signIn.join.company.2';
  };

  const getSubTitle = () => {
    if (step === STEP.SELECT) return 'signIn.join.select.type';
    if (step === STEP.VERIFY) return 'signIn.join.phone.message';
    return 'signIn.join.subtitle';
  };

  return (
    <div className='inner-container'>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        {step !== STEP.SELECT && (
          <div
            className='cursor-pointer no-drag'
            style={{ backgroundColor: '#EEEEEE', borderRadius: '8px', width: '30px', minHeight: '30px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            onClick={handleBack}
          >
            <img {...icBackArrow} alt='ic-arrow' style={{ transform: 'rotate(180deg)' }} />
          </div>
        )}
        {step === STEP.VERIFY && (
          <div style={{ color: '#666', fontSize: '15px', fontStyle: 'normal', fontWeight: '400', lineHeight: 'normal' }}>
            <IntlMessages id={businessType === BUSINESS_TYPE.INDIVIDUAL ? 'signIn.join.company.2' : 'signIn.join.personal.2'} />
          </div>
        )}
      </div>
      <div className='join-vi-title-wrapper'>
        <div className='join-vi-title no-drag'>
          <IntlMessages id={getTitle()} />
        </div>
        <div className='join-vi-sub-title'>
          <IntlMessages id={getSubTitle()} />
        </div>
      </div>
      {step === STEP.SELECT && <SelectForm onGoVerify={handleGoVerify} />}
      {step === STEP.VERIFY && <VerificationForm type={VERIFY_TYPE.SIGN_UP} businessType={businessType} goToNext={handleGoJoin} />}
      {step === STEP.JOIN && businessType === BUSINESS_TYPE.INDIVIDUAL && <IndividualJoinForm onCompleted={onCompleted} managerPhone={phone} otpCode={otpCode} isVi={true} />}
      {step === STEP.JOIN && businessType === BUSINESS_TYPE.FREELANCER && <FreelancerJoinForm onCompleted={onCompleted} managerPhone={phone} otpCode={otpCode} />}
      <div className='join-vi-text-wrapper' onClick={onChangeLogin}>
        <IntlMessages id='signIn.join.3' />{' '}
        <span className='join-text-blue'>
          <IntlMessages id='signIn.join.4' />
        </span>
      </div>
      {step === STEP.SELECT && (
        <div className='join-vi-staff-wrapper'>
          <div className='join-vi-staff-title cursor-pointer no-drag' onClick={() => setShowMethod(!showMethod)}>
            <IntlMessages id='signIn.join.staff.method' />
            <div className='join-vi-staff-arrow'>
              <img {...icArrow} alt='arrow' style={{ transform: showMethod ? 'rotate(270deg)' : 'rotate(90deg)' }} />
            </div>
          </div>
          <div className='join-vi-staff-sub' style={{ visibility: showMethod ? 'visible' : 'hidden' }}>
            <IntlMessages id='signIn.join.staff.sub' />
          </div>
        </div>
      )}
    </div>
  );
};

export default JoinViSection;
